export const router = {
  HOME: '/',
  LOGIN: '/login',
  WHEEL: '/wheel'
};
